export default "__VITE_ASSET__BSaoRqIr__"